import { Box, Typography } from "@mui/material";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";

import styles from "../../../assets/styles/componentStyles/billingStyles/changePlan.module.scss";

import { thousandSeparator, formatDateTime } from "../../../utils/constants";
import { getBillingCycleName } from "../utils.billing";
import { CYCLE_TYPES } from "../constant.billing";
import { billingSubscriptionPlan } from "../../../models/axiosModel";

interface NextBillingDateCardProps {
    plan: billingSubscriptionPlan | null | undefined;
    title?: string;
}

const NextBillingDateCard = ({ plan, title = "Next Billing Date" }: NextBillingDateCardProps) => {

    const currencySymbol = plan?.billing_plan_currency_symbol || "₹";
    const currencyCode = plan?.billing_plan_currency || "INR";
    const billingCycle = plan?.billing_plan_cycle_period_name || CYCLE_TYPES.MONTHLY;
    const nextChargeAmount = Number(plan?.razorpay_plan_amount) || 0;
    const nextChargeDate = plan?.next_charge_at ? formatDateTime(plan.next_charge_at, "dmTexty") : null;

    return (
        <Box className={styles.planSummaryCard}>
            <Box className={styles.cardHeader}>
                <Box className={styles.cardHeaderLeft}>
                    <Box className={styles.cardIconWrap}>
                        <EventAvailableOutlinedIcon className={styles.cardIcon} />
                    </Box>

                    <Typography className={styles.sectionLabel}>
                        {title}
                    </Typography>
                </Box>
            </Box>

            <Box>
                <Box className={styles.planRow}>
                    <Typography className={styles.planName}>
                        {nextChargeDate || "—"}
                    </Typography>

                    <Box className={styles.planPriceWrap}>
                        <Typography className={styles.planPrice}>
                            {currencySymbol || currencyCode}{thousandSeparator(nextChargeAmount)}
                        </Typography>

                        <Typography className={styles.billedLabel}>
                            Billed {getBillingCycleName(billingCycle)}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default NextBillingDateCard;
